// src/pages/Installation.js
import React from 'react';

function Installation() {
  return (
    <div>
      <h2>Installation</h2>
      <p>Instructions on how to install the software.</p>
    </div>
  );
}

export default Installation;
